export default "__VITE_ASSET__0qKIzDid__"